import { Component, Input } from '@angular/core';
import { TableData } from '@ddt-web/data-service';

@Component({
	selector: 'dl-simple-table',
	templateUrl: './simple-table.component.html',
	styleUrls: ['./simple-table.component.scss']
})
export class SimpleTableComponent {
	@Input() public data: TableData;
	@Input('striped') public isStriped: boolean = false;
	@Input('category-classes') public categoryColumnClass: string;
	@Input('data-classes') public dataColumnClass: string;
	@Input() public colors: string[];

	protected readonly DEFAULT_COLOR_THEME = '#000000';
}
